import { z } from "zod";

export const cargoIdSchema = z.string().uuid("ID de carga inválido");

export const createCargoSchema = z.object({
  name:        z.string().min(1, "El nombre es requerido").max(200),
  code:        z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  sgtCodes:    z.array(z.string().max(200)).nullable().optional(),
  cargoTypeId: z.string().uuid("ID de tipo de carga inválido").nullable().optional(),
});

export const updateCargoSchema = createCargoSchema.partial();

export const cargoQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

export const cargoTypeIdSchema = z.string().uuid("ID de tipo de carga inválido");

const cargoTypeCodeSchema = z.preprocess(
  (value) => (typeof value === "string" ? value.toUpperCase() : value),
  z
    .string()
    .min(1, "El código es requerido")
    .max(10, "Máximo 10 caracteres")
    .regex(/^[A-Z]+$/, "Usá solo letras"),
);

export const createCargoTypeSchema = z.object({
  name:      z.string().min(1, "El nombre es requerido").max(200),
  code:      cargoTypeCodeSchema,
  cargoDesc: z.enum(["PE", "NP"]).nullable().optional(),
});

export const updateCargoTypeSchema = createCargoTypeSchema.partial();

export const cargoTypeQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

export type CargoId = z.infer<typeof cargoIdSchema>;
export type CreateCargoInput = z.infer<typeof createCargoSchema>;
export type UpdateCargoInput = z.infer<typeof updateCargoSchema>;
export type CargoQuery = z.infer<typeof cargoQuerySchema>;
export type CargoTypeId = z.infer<typeof cargoTypeIdSchema>;
export type CreateCargoTypeInput = z.infer<typeof createCargoTypeSchema>;
export type UpdateCargoTypeInput = z.infer<typeof updateCargoTypeSchema>;
export type CargoTypeQuery = z.infer<typeof cargoTypeQuerySchema>;
